module.exports = __webpack_public_path__ + "static/media/6.48c4745d.JPG";